// shared/services/runtime-config.service.ts
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class RuntimeConfigService {
  private _config: any;

  get config() {
    return this._config;
  }

  get KENDO_UI_LICENSE(): string {
    return this._config?.KENDO_UI_LICENSE;
  }

  get privateKey(): string {
    return this._config?.PrivateKey;
  }

  get AesGcmPrivateKey(): string {
    return this._config?.AesGcmPrivateKey;
  }

  get secrateKey(): string {
    return this._config?.SecrateKey;
  }

  loadConfig(): Promise<void> {
    return fetch('/assets/config.json')
      .then(res => {
        if (!res.ok) throw new Error('Failed to load config.json');
        return res.json();
      })
      .then(data => {
        this._config = data;
      });
  }
}
